import { axiosServices } from "./axiosServices";

export const commonServices = { getSummary, getFieldConfig };

function getSummary(param) {
    return axiosServices.getAxios(`/v1/common/summary${param}`).then((res) => {
        return res;
    });
}

function getFieldConfig(param) {
    return axiosServices.getAxios(`/v1/common/field-configs${param}`).then((res) => {
        return res;
    });
}

